module.exports = __webpack_public_path__ + "static/img/22330067.88dcaac6.png";